// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IWaitingForFundsDto
 */
export interface IWaitingForFundsDto {
    /**
     * 
     * @type {boolean}
     * @memberof IWaitingForFundsDto
     */
    is_autopay?: boolean;
    /**
     * 
     * @type {Set<number>}
     * @memberof IWaitingForFundsDto
     */
    claim_ids?: Set<number>;
}

/**
 * Check if a given object implements the IWaitingForFundsDto interface.
 */
export function instanceOfIWaitingForFundsDto(value: object): value is IWaitingForFundsDto {
    return true;
}

export function IWaitingForFundsDtoFromJSON(json: any): IWaitingForFundsDto {
    return IWaitingForFundsDtoFromJSONTyped(json, false);
}

export function IWaitingForFundsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IWaitingForFundsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_autopay': json['is_autopay'] == null ? undefined : json['is_autopay'],
        'claim_ids': json['claim_ids'] == null ? undefined : new Set(json['claim_ids']),
    };
}

export function IWaitingForFundsDtoToJSON(json: any): IWaitingForFundsDto {
    return IWaitingForFundsDtoToJSONTyped(json, false);
}

export function IWaitingForFundsDtoToJSONTyped(value?: IWaitingForFundsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_autopay': value['is_autopay'],
        'claim_ids': value['claim_ids'] == null ? undefined : Array.from(value['claim_ids'] as Set<any>),
    };
}

